<script lang="ts" setup>
    import { ref, computed } from 'vue'

    const props = defineProps({
        lernziele: {
            type: String,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: false
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch' ? 'Learning outcomes and competences | Lernziele' : 'Lernziele'
    )

    const emit = defineEmits(['lernzieleSaved'])

    let editLernziele = ref('')

    function handleEditStart() {
        editLernziele.value = props.lernziele
    }

    function handleEditAbort() {
        editLernziele.value = ''
    }

    const savelernziele = () => {
        emit('lernzieleSaved', editLernziele.value)
    }
</script>

<template>
    <common-single-edit
        :entry="lernziele"
        edit-key="lernziele"
        :title="title"
        :tool-tip="tooltip"
        :allow-edit="allowEdit"
        @text-saved="savelernziele"
        @edit-aborted="handleEditAbort"
        @edit-started="handleEditStart"
    >
        <template #edit-component>
            <common-my-markup-editor v-model:content="editLernziele" />
        </template>
        <template #preview-component>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="lernziele" />
        </template>
    </common-single-edit>
</template>

<script></script>

<style scoped lang="scss"></style>
